import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";

import Loading from "../../Layouts/Loading";

import Toast from "../../Components/Toast";
import Navbar from "../../Layouts/Navbar";
import scorePic from "../../Assets/Images/scores.png"
import Header from "../../Layouts/Header";
import {useNavigate} from "react-router-dom";
import {SlBadge} from "react-icons/sl";
import {BiCategoryAlt,  BiSolidCube} from "react-icons/bi";


export default function Scores() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [scores, setScores] = React.useState([]);


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            window.location.replace('/login')
        }

        API.getScores()
            .then((response) => {
                setScores(response.data)
                setIsLoaded(true);
            })
            .catch((error) => {
                setIsLoaded(true);
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, []);



    return (
        <React.Fragment>
            <Toast />
            <Header title='امتیازهای دریافتی' hasBack={true}/>
            {
                !isLoaded && <Loading/>
            }
            <section className="container-fluid mt-3 rtl py-5 ">

                <div className="row">
                    <div className="col-12  "
                         onClick={() => navigate('/contents/جوایز')}
                    >
                        <img src={scorePic} alt="Scores" className='w-100'/>
                    </div>


                </div>

                <div className="row text-center m-2 score-box py-3">
                    <div className="col-1">
                        <SlBadge className='text-primary-color'/>
                    </div>
                    <div className="col-5 text-end text-small-1">
                        کل امتیاز دریافتی:
                    </div>
                    <div className="col-6 fw-bold text-start">
                        {
                            scores.total
                        }
                        &nbsp;
                        امتیاز
                    </div>
                </div>

                <div className="row text-center m-2  bg-secondary-subtle py-2 rounded">
                    <div className="col-1">
                        <SlBadge className='text-success'/>
                    </div>
                    <div className="col-5 text-end text-small-3">
                        مجموع امتیاز فصل گذشته:
                    </div>
                    <div className="col-6 fw-bold text-start text-small-2">
                        {
                            scores.previous_season_score
                        }
                        &nbsp;
                        امتیاز
                    </div>
                </div>
                <div className="row text-center m-2  bg-info-subtle py-2 rounded">
                    <div className="col-1">
                        <SlBadge className='text-success'/>
                    </div>
                    <div className="col-5 text-end text-small-3">
                        مجموع امتیاز فصل جاری:
                    </div>
                    <div className="col-6 fw-bold text-start text-small-2">
                        {
                            scores.current_season_score
                        }
                        &nbsp;
                        امتیاز
                    </div>
                </div>
                <div className="row text-center m-2  bg-success-subtle py-2 rounded">
                    <div className="col-1">
                        <SlBadge className='text-success'/>
                    </div>
                    <div className="col-5 text-end text-small-3">
                        مجموع امتیاز ماه جاری:
                    </div>
                    <div className="col-6 fw-bold text-start text-small-2">
                        {
                            scores.sumScoresM
                        }
                        &nbsp;
                        امتیاز
                    </div>
                </div>
                <div className="row text-center m-2 bg-secondary-subtle py-2 rounded ">
                    <div className="col-1">
                        <SlBadge className='text-secondary'/>
                    </div>
                    <div className="col-5 text-end text-small-3">
                        مجموع امتیاز ماه قبل:
                    </div>
                    <div className="col-6 fw-bold text-start text-small-2">
                        {
                            scores.sumScoresL
                        }
                        &nbsp;
                        امتیاز
                    </div>
                </div>
                <div className="row text-center m-2 bg-secondary-subtle py-2 rounded ">
                    <div className="col-1">
                        <SlBadge className='text-secondary'/>
                    </div>
                    <div className="col-5 text-end text-small-3">
                        مجموع امتیاز 2 ماه قبل:
                    </div>
                    <div className="col-6 fw-bold text-start text-small-2">
                        {
                            scores.sumScoresL2
                        }
                        &nbsp;
                        امتیاز
                    </div>
                </div>
            </section>

            <section className="container-fluid mt-3 rtl pb-5 ">
                <div className="row">
                    <div className="col-12 home-separator-text ">
                        <BiCategoryAlt className='mx-2'/>
                        امتیاز دریافتی از شرکت ها
                    </div>
                </div>
                {
                    isLoaded && scores.vendors.map(vendor => {
                        return (
                            <div className="row score-row m-3 p-3" key={vendor.id}
                                 onClick={() => navigate(`/vendor-orders/${vendor.id}`)}
                            >
                            <div className="col-7 text-small-1 fw-bold">
                                    {
                                        vendor.vendor
                                    }
                                    <div className='fw-normal text-small-3 text-muted mt-2'>
                                        <BiSolidCube className='ms-2' />
                                        از مجموع
                                        &nbsp;
                                        {
                                            vendor.count
                                        }
                                        &nbsp;
                                        فاکتور
                                    </div>
                                </div>
                                <div className="col-5 fw-bold text-start text-primary-color">
                                    {
                                        vendor.score
                                    }
                                    &nbsp;
                                    امتیاز
                                </div>
                            </div>
                        )
                    })
                }
                {
                    isLoaded && scores.vendors.length === 0 ?
                        <div className='alert alert-secondary text-center text-small-2 mt-3'>
شما                             هنوز امتیازی دریافت نکرده اید.
با ثبت سفارش و نهایی کردن سفارش خود (تحویل و تسویه با تامین کننده) امتیاز دریافت کنید
                        </div> : ''
                }
            </section>
            <Navbar />
        </React.Fragment>

    );
}

